import { Tooltip } from 'react-tooltip' # V5 (Docs: https://react-tooltip.com/docs/v5/options)

export default class AutoTranslationSettings extends React.PureComponent
  constructor: (props) ->
    super(props)

    @state =
      languageProjectLinks: @props.languageProjectLinks
      context:              @props.context
      contextSaving:        false
      contextSaved:         false # false on page-load, but never gets back to false later
      saving:               false

    @dSetSavingFalse        = _.debounce(@setSavingFalse,        400)
    @dSetContextSavingFalse = _.debounce(@setContextSavingFalse, 400)
    @dSaveContext           = _.debounce(@saveContext,           600)
    
    @updateContext = @updateContext.bind(this)
    @saveContext   = @saveContext.bind(this)

  componentDidMount: ->
    @bindPusher()

  bindPusher: ->
    testEnvSuffix = if @props.environment == 'test' then "-test#{@props.testEnvNumber}" else ''
    channel       = Pusher.instance.subscribe("private-project-#{@props.projectId}#{testEnvSuffix}-auto-translate")

    channel.bind('project-reload', =>
      @reloadLanguageProjectLinksFromBackend()
    )

  isContextTooLong: ->
    @state.context.length > @props.contextMaxLength

  updateContext: (event) ->
    @setState(
      context:       event.target.value
      contextSaving: true
      saving:        true
    , @dSaveContext)

  saveContext: ->
    http.put(@props.updateContextPath, { project: { context: @state.context.trim().slice(0, 1000) } }, (data) =>
      if data.success
        @dSetContextSavingFalse()
        @dSetSavingFalse()
    )

  clickOnTranslateNow: (link, event) ->
    event.preventDefault()

    if confirm("Are you sure to translate #{link.untranslatedSegmentsCount} segments into #{link.regionName} now?")
      http.post("#{link.autoTranslationPath}.json", {}, (response) =>
        @setState({ languageProjectLinks: response.languageProjectLinks })
      )

  toggleLinkAutoPerfectMatch: (link) ->
    @updateLinkParams(link, autoPerfectMatch: !link.autoPerfectMatch)

  toggleLinkAutoTranslate: (link) ->
    @updateLinkParams(link, autoTranslate: !link.autoTranslate)

  updateLinkService: (link, event) ->
    @updateLinkParams(link, service: event.target.value)

  updateLinkTone: (link, event) ->
    @updateLinkParams(link, tone: event.target.value)

  updateLinkParams: (link, newParams) ->
    # Update visually then on backend (then again visually with the backend response!)
    @stateUpdateLanguageProjectLink(link, newParams, =>
      @backendUpdateLanguageProjectLink(link, newParams)
    )

  stateUpdateLanguageProjectLink: (link, newParams, callback) ->
    index = _.findIndex(@state.languageProjectLinks, (languageProjectLink) => languageProjectLink.id == link.id)

    if index != undefined
      newLanguageProjectLink  = Object.assign({}, @state.languageProjectLinks[index], newParams)
      newLanguageProjectLinks = update(@state.languageProjectLinks, { [index]: { $set: newLanguageProjectLink } })
      @setState(languageProjectLinks: newLanguageProjectLinks, callback)
    else
      callback()

  backendUpdateLanguageProjectLink: (link, newParams) ->
    @setState(saving: true)

    http.put("#{link.path}.json", { languageProjectLink: newParams }, (response) =>
      @setState({ languageProjectLinks: response.languageProjectLinks }, @dSetSavingFalse) # wait a bit longer to remove spinner
    )

  reloadLanguageProjectLinksFromBackend: ->
    http.get("#{@props.languageProjectLinksPath}", {}, (response) =>
      @setState({ languageProjectLinks: response })
    )

  setContextSavingFalse: ->
    @setState(
      contextSaving: false
      contextSaved:  true
    )

  setSavingFalse: ->
    @setState(saving: false)

  isNeuroooService: (service) ->
    @props.neuroooServices.includes(service)

  servicesText: (link) ->
    services = []

    if link.autoPerfectMatch
      services.push("<strong>100% Match</strong>")
    
    if link.autoTranslate
      services.push("<strong>Google Translate</strong>")                   if link.service == 'google_translate'
      services.push("<strong>DeepL</strong>")                              if link.service == 'deepl'
      services.push("<strong>OpenAI · <small>Neurooo</small></strong>")    if link.service == 'openai'
      services.push("<strong>Anthropic · <small>Neurooo</small></strong>") if link.service == 'anthropic'
      services.push("<strong>DeepSeek · <small>Neurooo</small></strong>")  if link.service == 'deepseek'

    services.join(' and ')

  hasAutoTranslationAvailable: (link) ->
    link.googleTranslatable || link.deeplTranslatable || link.neuroooTranslatable

  render: ->
    <div className="col-12 col-xl-10 offset-xl-1 col-xxl-8 offset-xxl-2">
      <div className="panel">
        <div className="panel-header">
          <h1>Auto-translation</h1>
        </div>

        <div className="panel-body">
          { @renderExplanation() }
          { @renderWarning() }
          { @renderContext() }
          { @renderTable() }
          { @renderTagNote() }
        </div>

        <div className="panel-footer">
          <a className="btn btn-cancel" href={@props.settingsPath}>Back to Settings</a>
          { @renderSavingButton() }
        </div>
      </div>
    </div>

  renderExplanation: ->
    neuroooEnginesText = "OpenAI, Anthropic and DeepSeek LLMs"

    <div className="explanation">
      <p>
        Automatically translate new segments that have been added during a synchronization.
      </p>

      <ul>
        <li>
          <strong>100% Match</strong> will perform a lookup in your Translation Memory to find a translated segment with the exact same source.
          If found, its translation will be used.
        </li>
        <li>
          <strong>Auto-Translate</strong> will request a translation
          from <a target="_blank" href="https://translate.google.com">Google Translate</a>,
          {' '}
          <a target="_blank" href="https://deepl.com">DeepL</a>
          {' '}or{' '}
          a <a target="_blank" href="https://neurooo.com/api">Neurooo</a> service <small>({neuroooEnginesText})</small>.
          It will not be perfect but it will certainly be good enough until someone proofread it.
        </li>
      </ul>
    </div>

  renderContext: ->
    <div className="project-context">
      <label className="form-label" htmlFor="project-context">
        Project context
      </label>

      { @renderContextSavingBadge() }
      { @renderContextTextarea() }
      { @renderContextNote() }
      { @renderContextCounter() }
    </div>

  renderContextSavingBadge: ->
    if @state.contextSaving
      <span className="badge badge-saving">
        <i className="fas fa-spinner fa-spin" />
      </span>
    else if @isContextTooLong()
      <span className="badge badge-too-long">
        Context too long
      </span>
    else if @state.contextSaved
      <span className="badge badge-saved">
        Saved
      </span>

  renderContextTextarea: ->
    classes = "form-control"
    classes += " is-too-long" if @isContextTooLong()
    
    placeholder = """
      Example: “Web Application about financial products related to housing and loans. Direct communication with customers should stay professional. The name of the company, \"Direct Bank\", shouldn't be translated. Website is direct-bank.com.”
    """

    <TextareaAutosize className={classes}
                      name="project-context"
                      id="project-context"
                      minRows={2}
                      value={@state.context}
                      placeholder={placeholder}
                      onChange={@updateContext} />

  renderContextNote: ->
    <div className="form-text">
      Context helps <a href="https://neurooo.com/api" target="_blank">Neurooo</a> services provide better translations.
    </div>

  renderContextCounter: ->
    classes = "form-text text-end"

    if @isContextTooLong()
      <div className={"#{classes} text-danger"}>
        <i className="fas fa-triangle-exclamation" />
        &nbsp;
        {@state.context.length}/{@props.contextMaxLength}
      </div>
    else
      <div className={classes}>
        {@state.context.length}/{@props.contextMaxLength}
      </div>

  renderTable: ->
    tooltipId = "translation-service"

    <table className="table align-middle">
      <thead>
        <tr>
          <th className="a">
            Target Language
          </th>
          <th className="b">
            100% Match
          </th>
          <th className="c">
            Auto-Translate
          </th>
          <th className="d">
            Translation Service&nbsp;
            <i className="fas fa-circle-info" data-tooltip-id={tooltipId} />
            <Tooltip id={tooltipId}
                     variant="light"
                     place="top"
                     content="This translation service will also be used to provide suggestions during the translation process.">
            </Tooltip>
          </th>
          <th className="e">
            Actions
          </th>
        </tr>
      </thead>

      <tbody>
        { @renderLanguageProjectLinks() }
      </tbody>
    </table>

  renderWarning: ->
    if !@props.canBeAutoTranslated
      <div className="alert alert-danger alert-billing" role="alert">
        <strong>Warning:</strong>
        Please <a href="/settings/billing">update your billing information</a> to
        continue using our auto-translation services.
      </div>

  renderTagNote: ->
    if @props.canBeAutoTranslated
      <div className="alert alert-warning" role="alert">
        <strong>Note:</strong>

        <em className="tag">{@props.perfectMatchTagName}</em> or <em className="tag">{@props.autoTranslatedTagName}</em> tags
        will be added to the corresponding segments for your translators to be able to proofread and validate them.
      </div>

  renderLanguageProjectLinks: ->
    @state.languageProjectLinks.map((link) =>
      dClass = 'd'
      dClass += ' d-with-select' if @hasAutoTranslationAvailable(link)

      <tr className={"language-#{link.code}"} key={link.id}>
        <td className="a">
          { link.regionName } • { link.code }
        </td>
        <td className="b">
          { @renderPerfectMatchCol(link) }
        </td>
        <td className="c">
          { @renderAutoTranslateCol(link) }
        </td>
        <td className={dClass}>
          { @renderTranslationServiceCol(link) }
        </td>
        <td className="e">
          { @renderAutoTranslateButtonCol(link) }
        </td>
      </tr>
    )

  renderPerfectMatchCol: (link) ->
    @renderPerfectMatchCheckbox(link)

  renderAutoTranslateCol: (link) ->
    if @hasAutoTranslationAvailable(link)
      @renderAutoTranslateCheckbox(link)
    else
      <span>
        <em style={color: '#999999'}>Not Available</em>
      </span>

  renderTranslationServiceCol: (link) ->
    if @hasAutoTranslationAvailable(link)
      selectClasses  = 'form-select service-selector'
      selectClasses += ' disabled' if !link.autoTranslate

      <>
        <select className={selectClasses}
                id={"select-service-#{link.code}"}
                name={"select-service-#{link.code}"}
                value={link.service}
                onChange={@updateLinkService.bind(this, link)}>
          { @renderServiceOptions(link) }
        </select>

        { @renderNeuroooTooltip(link) }

        { @renderToneSelector(link) }
      </>
    else
      <em style={color: '#999999'}>None</em>

  renderServiceOptions: (link) ->
    # Only keep options for current language
    serviceOptions = @props.serviceOptions.filter((serviceOption) =>
      return true if serviceOption[1] == 'google_translate' && link.googleTranslatable
      return true if serviceOption[1] == 'deepl'            && link.deeplTranslatable
      return true if @isNeuroooService(serviceOption[1])    && link.neuroooTranslatable
      return false
    )

    _.map(serviceOptions, (option, index) =>
      <option key={index} value={option[1]}>
        {option[0]}
      </option>
    )

  renderNeuroooTooltip: (link) ->
    if @isNeuroooService(link.service)
      tooltipId = "neurooo-tooltip-#{link.id}"
      
      <>
        <i className="neurooo-icon" data-tooltip-id={tooltipId} />
        <Tooltip id={tooltipId} variant="light" place="top" className="neurooo-tooltip">
          <div className="tooltip-header">
            Neurooo service
          </div>
          <div className="tooltip-body">
            LLM model: {@props.neuroooEngines[link.service].name}
          </div>
        </Tooltip>
      </>

  renderToneSelector: (link) ->
    if link.serviceSupportsTone
      selectClasses  = 'form-select tone-selector'
      selectClasses += ' disabled' if !link.autoTranslate

      toneOptions = _.map(@props.toneOptions, (option, index) =>
        <option key={index} value={option[1]}>
          {option[0]}
        </option>
      )

      tooltipId = "tone-selector-#{link.id}"

      <div className="tone-selector-wrapper">
        <i className="fas fa-gauge" data-tooltip-id={tooltipId} />
        <Tooltip id={tooltipId} variant="light" place="left">
          { @renderToneSelectorPopoverContent(link.service)}
        </Tooltip>
        <select className={selectClasses}
                id={"select-tone-#{link.code}"}
                name={"select-tone-#{link.code}"}
                value={link.tone}
                onChange={@updateLinkTone.bind(this, link)}>
          {toneOptions}
        </select>
      </div>

  renderToneSelectorPopoverContent: (service) ->
    if service == 'deepl'
      <>
        DeepL allows you to choose the level of <strong>formality</strong> for this language.
      </>
    else if @isNeuroooService(service)
      <>
        Neurooo allows you to choose the level of <strong>formality</strong> for this language.
      </>

  renderAutoTranslateButtonCol: (link) ->
    if link.untranslatedSegmentsCount == 0
      <a className="btn btn-default btn-sm disabled disabled-green">
        Already translated
      </a>
    else if link.autoTranslationInProgress
      <a className="btn btn-default btn-sm disabled">
        In progress&nbsp;
        <i className="fas fa-spinner fa-spin"></i>
      </a>
    else if !@props.canBeAutoTranslated
      <a className="btn btn-default btn-sm disabled">
        No actions available
      </a>
    else
      if link.autoTranslate || link.autoPerfectMatch
        popoverContent = "Translate <span class='badge'>#{link.untranslatedSegmentsCount}</span> untranslated segments using #{@servicesText(link)}."
        classes        = "btn btn-primary btn-sm"
        styles         = {}
        action         = @clickOnTranslateNow.bind(this, link)
      else
        popoverContent = "Select a service to translate <span class='badge'>#{link.untranslatedSegmentsCount}</span> untranslated segments."
        classes        = "btn btn-primary btn-sm disabled"
        styles         = { pointerEvents: 'auto' } # to be able to show popover even with disabled button
        action         = (e) -> e.preventDefault();

      tooltipId = "translate-button-#{link.id}"

      # Using <> wrapper instead of [] because array requires key props on children
      <>
        <a className={classes}
           style={styles}
           onClick={action}
           href="#"
           data-tooltip-id={tooltipId}>
          Translate now
        </a>
        <Tooltip id={tooltipId}
                 variant="light"
                 place="right"
                 html={popoverContent}>
        </Tooltip>
      </>

  renderPerfectMatchCheckbox: (link) ->
    <input className="form-check-input"
           type="checkbox"
           name={"checkbox-perfect-match-#{link.code}"}
           checked={link.autoPerfectMatch}
           onChange={@toggleLinkAutoPerfectMatch.bind(this, link)} />

  renderAutoTranslateCheckbox: (link) ->
    <input className="form-check-input"
           type="checkbox"
           name={"checkbox-auto-translate-#{link.code}"}
           checked={link.autoTranslate}
           onChange={@toggleLinkAutoTranslate.bind(this, link)} />

  renderSavingButton: ->
    classes = 'btn'
    classes += ' btn-primary' if !@state.saving
    classes += ' btn-warning' if @state.saving

    <a className={classes} type="submit" name="commit">
      { @renderSavingButtonContent() }
    </a>

  renderSavingButtonContent: ->
    if @state.saving
      <span>
        <i className="fas fa-spinner fa-spin fa-lg"></i>
      </span>
    else
      <span>
        Saved
      </span>
